import { alert } from "../core/alert";
import { date } from "../core/date";
import { errorCode, getErrorMessage, getErrorMessageHeader } from "../core/errorHandling";
import { getErrorCode } from "../core/getErrorCode";
import { emptyFn } from "../core/util";

export function originalAjax(settings) {
    if (settings.type == "POST") {
        settings.data = settings.data || "{}";
    }

    settings.url = (settings.urlPrefix || "") + (settings.url || "");
    settings.url = settings.url.replace("#", "%23");

    settings.cache = settings.cache || true;
    settings.contentType = settings.contentType || "application/json";
    settings.dataType = settings.dataType || "json";
    settings.timeout = settings.timeout || 300000;
    settings.data = JSON.stringify(settings.data);

    var originalBeforeSend = settings.beforeSend || emptyFn;

    settings.beforeSend = function (xhr, options) {
        xhr.startDateTime = date(new Date());

        xhr.correlationId = options.headers["Correlation-Id"];
        xhr.correlationGroupId = options.headers["Correlation-Group-Id"];
        const requestUrl = options.url;
        if (requestUrl && requestUrl.contains("/service/api/")) {
            xhr.requestUrl = requestUrl.split("/service/api/")[1];
        } else {
            xhr.requestUrl = requestUrl;
        }

        originalBeforeSend(xhr, options);
    };

    var originalError = settings.error || emptyFn;

    settings.error = function (xhr, options) {
        xhr.endDateTime = date(new Date());
        xhr.duration = Math.abs(xhr.startDateTime.getTime() - xhr.endDateTime.getTime());

        originalError(xhr, options);
    };

    return $.ajax(settings);
}

export function attachAjaxErrorMessageHandler() {
    $(document).ajaxError(function (event, xhr, settings: any) {
        if (!settings.errorHandled && xhr.statusText != "abort" && xhr.status != 401) {
            var responseErrorCode = getErrorCode(xhr);

            if (responseErrorCode != errorCode.GeneralError) {
                var responseMessage = getErrorMessage({ errorCode: responseErrorCode }),
                    header = getErrorMessageHeader({ errorCode: responseErrorCode });
                alert({ type: "danger", header: header, message: responseMessage });
            }
        }
    });
}

export function attachErrorAlerts() {
    $(document).ajaxError(function (event, xhr, settings: any) {
        if (!settings.errorHandled && xhr.statusText != "abort" && xhr.status != 401) {
            var responseErrorCode = getErrorCode(xhr);
            var responseMessage = getErrorMessage({ errorCode: responseErrorCode }),
                header = getErrorMessageHeader({ errorCode: responseErrorCode });
            alert({ type: "danger", header: header, message: responseMessage });
        }
    });
}
